import React, { useContext, useEffect } from "react";
import { Map, TileLayer, Circle, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { SelfIcon } from "geospatial/SelfIcon";

import LocationContext from "geospatial/contextLocation";
import { useLiveSubscriptions, useLiveDialogs } from "hooks/dbHooks";

const UIMap = (props) => {
  const { locationState, locationDispatch } = useContext(LocationContext);
  const liveSubscriptions = useLiveSubscriptions(props.db);

  useEffect(() => {
    if (liveSubscriptions !== undefined) {
      let mapTopics = document.getElementById("mapTopics");
      liveSubscriptions.map((sub) => {
        console.log({
          topic: sub.topic,
          lat: sub.topic_props.location?.lat ?? undefined,
          lon: sub.topic_props.location?.lon ?? undefined,
          range: sub.topic_props.range,
        });
      });
    }
    return () => {};
  }, [liveSubscriptions]);

  let content =
    locationState.useLocation === "false" ? (
      <div></div>
    ) : (
      <div className="UI-map-frame">
        <Map
          id="mapTopics"
          className="UI-map"
          center={[locationState.latitude, locationState.longitude]}
          zoom={10}
        >
          <TileLayer
            //   attribution={
            //     '&copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            //   }
            url={"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}
          />
          <Marker
            position={{
              lat: locationState.latitude,
              lng: locationState.longitude,
            }}
            icon={SelfIcon}
          ></Marker>
          {liveSubscriptions === undefined
            ? {}
            : liveSubscriptions.map((sub) =>
                sub.topic_props.range > 200 ? (
                  <div></div>
                ) : (
                  <Circle
                    center={{
                      lat: sub.topic_props.location?.lat ?? 0,
                      lng: sub.topic_props.location?.lon ?? 0,
                    }}
                    fillColor="#add036"
                    color="#add036"
                    radius={1000 * (sub.topic_props.range ?? 0)}
                  />
                )
              )}
          {/* <Circle 
                  center={{lat:elem.location.latitude, lng: elem.location.longitude}}
                  fillColor="blue" 
                  radius={200}/> */}
        </Map>
      </div>
    );

  return content;
};

export default React.memo(UIMap, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
